import {Component, HostListener} from '@angular/core';
import {ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {ViewportScroller} from '@angular/common';
import {filter, first, map, mergeMap} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {Store} from '@ngrx/store';

import {StoreService} from './core/store/store.service';
import {UtilsService} from './shared/services/utils.service';

import {RefreshStoreAction} from 'src/app/core/actions/actions';
import {environment} from 'src/environments/environment';
import {LIGHTBOX_EVENT, LightboxConfig, LightboxEvent} from 'ngx-lightbox';
import {Subscription} from 'rxjs';
import {SEOService} from './shared/services/seo.service';
import {ApiService} from './shared/services/api.service';
import {CartService} from './shared/services/cart.service';
import {AuthenticationService} from './shared/services/authentication.service';

// tslint:disable-next-line:ban-types
declare let gtag: Function;
declare var $: any;

@Component({
    selector: 'indiapicture-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent {
    private myObserver: Subscription;

    constructor(
        public store: Store<any>,
        public router: Router,
        public utilsService: UtilsService,
        public apiService: ApiService,
        public cartService: CartService,
        public authenticationService: AuthenticationService,
        public modalService: NgbModal,
        private _lightboxEvent: LightboxEvent,
        private _lightboxConfig: LightboxConfig,
        private seoService: SEOService,
        private activatedRoute: ActivatedRoute,
        private StorageService: StoreService
    ) {
        const navigationEnd = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        );

        navigationEnd.pipe(first()).subscribe(() => {
            document.querySelector('body')?.classList.add('loaded');
            var timer = setInterval(() => {
                if (window.getComputedStyle(document.querySelector('body')).visibility == 'visible') {
                    clearInterval(timer);
                    $('.owl-carousel').trigger('refresh.owl.carousel');
                }
            }, 300);
        });

        navigationEnd.subscribe((event: any) => {
            // if (!event.url.includes('/shop/sidebar') && !event.url.includes('/shop/nosidebar') && !event.url.includes('/shop/market') && !event.url.includes('/blog')) {
            //     this.viewPort.scrollToPosition([0, 0]);
            // }

            this.modalService.dismissAll();

          const user =  StorageService.getItem('currentUser');
        //   if(user && user?.isExclusive == false){
            this.cartService.getCartList();
        //   }

        });

        if (localStorage.getItem('indiapicture-angular-demo') !== environment.demo) {
            this.store.dispatch(new RefreshStoreAction());
        }

        localStorage.setItem('indiapicture-angular-demo', environment.demo);
        _lightboxConfig.fadeDuration = 0.2;
        _lightboxConfig.disableScrolling = true;
        _lightboxConfig.albumLabel = 'Image %1 of %2';
        // _lightboxConfig.showZoom = true;
        _lightboxConfig.centerVertically = true;

    }

    private _subscription: Subscription;

    open(index: number): void {
        // register your subscription and callback whe open lightbox is fired
        this._subscription = this._lightboxEvent.lightboxEvent$
            .subscribe(event => this._onReceivedEvent(event));
    }

    private _onReceivedEvent(event: any): void {
        // remember to unsubscribe the event when lightbox is closed
        if (event.id === LIGHTBOX_EVENT.CLOSE) {
            // event CLOSED is fired
            this._subscription.unsubscribe();
        }
    }


    recallJsFuntions() {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    // Nothing to raise when the destination runs without it. The
                    // handler below still hides it on arrival, so a preloader
                    // already up when the navigation started comes down.
                    if (this.utilsService.suppressesPreloader(event.url)) {
                        return;
                    }

                    $('.preloader').fadeIn('slow');
                }
            });
        /*
         * NavigationError belongs here too.
         *
         * The preloader is shown on NavigationStart and hidden on whatever ends
         * the navigation — but a navigation that THROWS ends in NavigationError,
         * which this did not listen for. Anything that threw on the way out of a
         * page (a component's ngOnDestroy, a resolver) therefore left the spinner
         * running with no way to clear it, and the site looked frozen.
         *
         * A specific case of that is fixed in CheckoutComponent, but the failure
         * mode is general: the overlay must come down however the navigation ends.
         */
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd
                || event instanceof NavigationCancel
                || event instanceof NavigationError))
            .subscribe(event => {

                /*
                 * stop(true, true) first: jQuery queues fades, so a fadeIn the
                 * interceptor queued a moment earlier would otherwise run AFTER
                 * this fadeOut and leave the sheet up. The studio never shows it
                 * at all, so arriving there takes it down at once.
                 */
                const url = (event as NavigationEnd).urlAfterRedirects || (event as any).url;
                if (this.utilsService.suppressesPreloader(url)) {
                    $('.preloader').stop(true, true).hide();
                } else {
                    $('.preloader').stop(true, true).fadeOut('slow');
                }
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

    @HostListener('window: scroll', ['$event'])
    onWindowScroll(e: Event) {
        this.utilsService.setStickyHeader();
    }

    hideMobileMenu() {
        document.querySelector('body').classList.remove('mmenu-active');
        document.querySelector('html').style.overflowX = 'unset';
    }

    ngOnInit() {
        this.recallJsFuntions();
        const hostName = 'https://indiapicture.in';
        this.myObserver = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
        )
            .subscribe((event) => {

                // gtag('config', 'UA-162330039-1', {page_path: event.url});
                this.updatePageView(this.router.url);
                this.seoService.updateTitle(event['title']);
                this.seoService.updateData('description', event['description']);
                this.seoService.updateData('keyword', event['keyword']);
                /*
                 * Production is indexable; everything else must not be.
                 *
                 * Both branches used to emit noindex, with the index line
                 * commented out -- presumably from a staging period. Shipping
                 * that to production tells Google to drop every page.
                 */
                if (environment.production) {
                    this.seoService.updateData('robots', 'index, follow');
                } else {
                    this.seoService.updateData('robots', 'noindex, nofollow');
                }
                if (event['canonical']) {
                    //     this.seoService.updateCanonicalUrl(hostName+event['canonical']);
                    // } else {
                    this.seoService.updateCanonicalUrl(hostName + this.router.url);
                } else {
                    this.seoService.removeCanonicalUrl();
                }
            });
    }

    private updatePageView(url) {
        // this.apiService.addPageView(url, url == '/subscription' ? 1 : 0).subscribe(data => {
        //     if (data.statusCode === 200) {
        //
        //     }
        // });
    }
}
